import { Injectable }             from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map }        from 'rxjs/operators';

import { environment }      from '../../../environments/environment';
import { TransformClass }   from '../../shared/utils/transform';
import { RestResponse }     from '../../shared/models/rest';
import { PaymentPackage }   from '../../shared/models/payment/payment-package';
import { TransactionStart } from '../../shared/models/payment/transaction-start';
import { PurchasesReport } from 'src/app/shared/models/purchases-report/get-purchases-report';
import { SearchPurchasesFilters } from 'src/app/shared/models/purchases-report/search-purchases-report-filter';
import { RestPaginationAndSortingParams } from 'src/app/shared/models/rest/rest-pagination-and-sorting-params';
import { RestPaged } from 'src/app/shared/models/rest/rest-paged';


@Injectable({ providedIn: 'root' })
export class ApiPaymentService {

  private readonly baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = `${ environment.apiUrl }/venda`;
  }

  public getPackages(): Observable<PaymentPackage[]> {
    return this.http.get<RestResponse>(`${ this.baseUrl }/pacotes/ativos`).pipe(
      map(response => response.data as PaymentPackage[])
    );
  }

  public getPackage(
    id:      number,
    coupon?: string
  ): Observable<PaymentPackage> {

    const httpParams: HttpParams = TransformClass.httpParams({ cupom: coupon });

    return this.http.get<RestResponse>(
      `${ this.baseUrl }/pacotes/${ id }`,
      { params: httpParams }
    ).pipe(map(response => response.data as PaymentPackage));
  }

  public startTransaction(
    packageId: number,
    coupon?: string,
    paymentMethodId: string = 'PAGAR.ME'
  ): Observable<TransactionStart> {
    const body = {
      meioPagamentoId: paymentMethodId,
      pacoteId:        packageId,
      cupom:           coupon,
    };

    return this.http.post<RestResponse>(
      `${ this.baseUrl }/pagamento/inicia`, body
    ).pipe(map(response => response.data as TransactionStart));
  }

  public finishTransaction(
    situation:        'SUCCESS' | 'ERROR' | 'CLOSE',
    transactionIdRed: number,
    transactionId?:   string,
    errorMsg?:        string
  ): Observable<void> {
    const body = {
      situacaoCheckoutPagamento: situation,
      transacaoRed1000Id:        transactionIdRed,
      transacaoId:               transactionId,
      msgErro:                   errorMsg,
    };

    return this.http.post<void>(`${ this.baseUrl }/pagamento/finaliza`, body);
  }

  public getSearchPurchases(
    filterParams:     SearchPurchasesFilters,
    paginationParams: RestPaginationAndSortingParams = {}
  ): Observable<RestPaged<PurchasesReport[]>> {
    const httpParams: HttpParams = TransformClass.httpParams({
      ...filterParams,
      ...TransformClass.formatPaginationParams(paginationParams)
    });

    return this.http.get<RestPaged<PurchasesReport[]>>(
      `${ this.baseUrl }/relatorio`, { params: httpParams }
    );
  }

  public invoiceCancellation(transacaoId: number): Observable<void> {
    return this.http.post<void>(`${ this.baseUrl }/${ transacaoId }/solicitacao/cancelamento/notafiscal`, transacaoId);
  }

  // public invoiceCancellation(transacaoId: number): Observable<void> {
  //   return this.http.post<void>(`${ this.baseUrl }/${ transacaoId }/solicitacao/cancelamento/notafiscal`);
  // }
}
